import script from "./TotalOne.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalOne.vue?vue&type=script&setup=true&lang=js"

import "./TotalOne.vue?vue&type=style&index=0&id=7575a011&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7575a011"]])

export default __exports__